import React from "react";
// import { LoginAction } from "../../actions/user/login";
import store from "../../../store";
import { connect } from "react-redux";
import { IN_PROCESS, QUOTE, TO_QUOTE_CREATE, TO_QUOTE_LIST } from "../../../helpers/constants";
import Link from "react-router-dom/Link";
// import { MDBSelect } from "mdbreact";
import { email, gt0, numbers, required } from "../../../helpers/form-validation";
import { Button, Row, Col, Table, FormControl, FormLabel, Modal } from "react-bootstrap";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import "./quote-form.scss";
import Select2 from 'react-select'
import Select, { select } from "react-validation/build/select";
import {
	fetchProductOptions,
	GetCountries,
	GetProducts,
	GetQuote,
	SaveExternalQuote,
	SaveEndUser,
	GetEndUsers
} from "../../../actions/quote/quote-actions";
import { getUser, parseFreeAccessoriesForView, toast } from "../../../helpers/utility";
import { BASE_URL } from "../../../api/constants";
import customerTopSection, { CustomerTopSection } from "./customer-top-section";
import { E2BIG } from "constants";
import {CreateEndUser} from "./create-enduser";
import { QuoteDetailsStep } from "./quote-details-step";
import { QuoteProductsStep } from "./quote-products-step";
import { QuoteReviewStep } from "./quote-review-step";
// import { timeStamp } from "console";
class QuoteForm extends React.Component {
	constructor(props) {
		super(props);
		this.createEndUserFormRef = React.createRef();
		this.handleChange = this.handleChange.bind(this);
		this.handleOnSubmit = this.handleOnSubmit.bind(this);
		this.sameAsBilling = this.sameAsBilling.bind(this);
		this.sameAsShipping = this.sameAsShipping.bind(this);
		this.body = this.body.bind(this);		
		this.state = {
			quote: {
				Quote_Comments: ''
			},
			options: [],
			selectedProducts: [],
			redirect: "",
			total: 0,
			sameAsBilling: true,
			selectValue: [],
			selectOption:[],
			type: "",
			popupFlag: false,
			href:"",
			CategoryOptions : [],
			showModal: false,
			currentStep: 1,
			isSubmitting: false,
			submissionError: "",
			completedQuoteNo: null,
			isInitialLoading: true,
			initialLoadError: "",
			endUser: {
				firstName: "",
				lastName: "",
				emailAddress: "",
				companyName: "",
				phoneNumber: "",
				BillingAddress1: "",
				BillingAddress2: "",
				City: "",
				PostalCode: "",
				State: "",
				Country: "",
			  },
		};
		// this.emptyProduct = {};
	}
	goToStep = (step) => {
		this.setState({ currentStep: step, submissionError: "" }, () => {
			window.scrollTo({ top: 0, behavior: "smooth" });
		});
	};
	continueToNextStep = () => {
		if (this.state.currentStep === 1 && !this.validateQuoteDetails()) return;
		if (this.state.currentStep === 2 && !this.validateProducts()) return;
		this.goToStep(this.state.currentStep + 1);
	};
	validateQuoteDetails = () => {
		const requiredFields = [
			"BillingFirstName", "BillingLastName", "CustomerEmail",
			"ShipCompanyName", "ShipAddress1", "ShipCity", "ShipState", "ShipCountry", "ShipPhoneNumber",
		];
		if (!this.state.sameAsBilling) {
			requiredFields.push("BillingCompanyName", "BillingAddress1", "BillingCity", "BillingState", "BillingCountry", "BillingPhoneNumber");
		}
		const missingField = requiredFields.find((name) => !String(this.state.quote[name] || "").trim());
		if (missingField) {
			this.setState({ submissionError: "Complete all required customer and address fields before continuing." });
			setTimeout(() => document.getElementById(missingField)?.focus(), 0);
			return false;
		}
		if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.quote.CustomerEmail)) {
			this.setState({ submissionError: "Enter a valid customer email address before continuing." });
			setTimeout(() => document.getElementById("CustomerEmail")?.focus(), 0);
			return false;
		}
		return true;
	};
	validateProducts = () => {
		const invalidProduct = !this.state.selectedProducts.length || this.state.selectedProducts.some(
			(product) => !product.ProductCode || Number(product.Quantity) <= 0
		);
		if (invalidProduct) {
			this.setState({ submissionError: "Select a part number and enter a quantity greater than zero for each item." });
			return false;
		}
		return true;
	};
	handleChange(e, index, childIndex) {
		let selectedProducts = this.state.selectedProducts;
		// console.log(index,this.state.selectedProducts);
		let quote = this.state.quote;
		// if (e.target.name === "productList") {
		// 	let productCode = e.target.value;
		// 	let product = this.props.products.find(
		// 		({ ProductCode }) => ProductCode === productCode
		// 	);
		// 	let productChilds = parseFreeAccessoriesForView(
		// 		product,
		// 		this.props.products
		// 	);
		// 	if (productChilds.length > 0) {
		// 		productChilds.forEach((elem) => {
		// 			// elem.ProductPrice = 0
		// 			elem.ProductPrice = 0;
		// 			elem.isChild = 1;
		// 			elem.parent = productCode;
		// 			product.ProductDescriptionShort = product.ProductDescriptionShort ? product.ProductDescriptionShort.replace(/style="[^"]*"/g, "") : '';
		// 		});
		// 	}
		// 	product.Childs = productChilds || [];
		// 	product.Quantity = 1;
		// 	product.parentName = product.ProductCode;
		// 	product.isChild = 0;
		// 	product.ProductPrice = product.ProductPrice;
		// 	product.Discription = product.ProductDescriptionShort ? product.ProductDescriptionShort.replace(/style="[^"]*"/g, "") : '';
		// 	selectedProducts[index] = product;
		// 	this.setState({ selectedProducts });
		// 	this.updateTotal();
		// } else 
		if (e.target.name === "Quantity") {
			selectedProducts[index].Quantity = e.target.value;

			this.setState({ selectedProducts });
			this.updateTotal(false);
		} else if (e.target.name === "ProductPrice") {
			// if (!this.props.quote.lineItems) {
			// 	selectedProducts[index].ProductPrice = e.target.value ? e.target.value : 1;
			// } else {
			selectedProducts[index].ProductPrice = e.target.value
			// }
			this.setState({ selectedProducts });
			this.updateTotal(false);
		} else if (e.target.name === "productDescription") {
			selectedProducts[index].Discription = e.target.value
			this.setState({ selectedProducts });
		} else if (e.target.name === "productDescriptionChild") {
			selectedProducts[index].Childs[childIndex].ProductDescriptionShort = e.target.value
			this.setState({ selectedProducts });
		} 
		else {
			// strip invisible unicode (zero-width spaces/joiners, BOM) mobile keyboards/paste can insert; MySQL rejects it (ER_TRUNCATED_WRONG_VALUE_FOR_FIELD)
			const value = typeof e.target.value === "string"
				? e.target.value.replace(/[\u200B-\u200F\u202A-\u202E\uFEFF]/g, "")
				: e.target.value;
			quote[e.target.name] = value;
			if (this.state.sameAsBilling && e.target.name.indexOf("Ship") === 0) {
				const billingField = e.target.name.replace("Ship", "Billing");
				quote[billingField] = value;
			}
		}
		// quote.lineItems = selectedProducts;
		this.setState({ quote });
		this.updateTotal(false);
	}
	handleEndUserChange = (e) => {
		const quote = this.state.quote;
		quote.endUserId = e.value;
		this.setState({
			quote: quote
		})
	}
	handleSelectChange = (selectValue, index) => {
		// console.log(selectValue, index)
		let productChilds = []
		let selectedProducts = this.state.selectedProducts;
		let selectValueArray = this.state.selectValue
		let productCode = selectValue.label;
		let product = this.props.activeProducts.find(
			({ ProductCode }) => ProductCode === productCode
		);
		if(product){

			product = JSON.parse(JSON.stringify(product))
			const parentName = this.getUniqueParentName(product.ProductCode, selectedProducts);
			productChilds = parseFreeAccessoriesForView(
				product,
				this.props.products
			);
			if (productChilds.length > 0) {
				productChilds.forEach((elem) => {
					elem.ProductPrice = 0;
					elem.isChild = 1;
					elem.isCategoriesOption = 0
					elem.parent = parentName;
					// elem.ProductPrice = 0
					product.ProductDescriptionShort = product.ProductDescriptionShort ? product.ProductDescriptionShort.replace(/style="[^"]*"/g, "") : '';
				});
			}
			product.Childs = productChilds || [];
			product.Quantity = 1;
			product.parentName = parentName;
			product.isChild = 0;
			product.ProductPrice = product.ProductPrice;
			product.isCategoriesOption = 0
			product.Discription = product.ProductDescriptionShort ? product.ProductDescriptionShort.replace(/style="[^"]*"/g, "") : '';
			selectedProducts[index] = product;
			selectValueArray[index] = selectValue
			this.setState({ selectedProducts, selectValue: selectValueArray });
			this.updateTotal(false);
			store.dispatch(fetchProductOptions(product.OptionIDs,index));
		}
	}
	randomString = () => {
		return Math.random().toString(36).substring(6);
	}
	getUniqueParentName = (productCode, rows = [], existingKeys) => {
		const prefix = productCode || "line";
		const usedKeys = existingKeys || new Set();
		if (!existingKeys) {
			(rows || []).forEach((row) => {
				if (row && row.parentName) usedKeys.add(row.parentName);
			});
		}
		let parentName = `${prefix}${this.randomString()}`;
		while (usedKeys.has(parentName)) {
			parentName = `${prefix}${this.randomString()}`;
		}
		return parentName;
	}
	normalizeParentRelationships = (rows = []) => {
		const usedKeys = new Set();
		let currentParent = null;
		let optionKeys = new Map();

		rows.forEach((row) => {
			if (!row) return;
			const isChild = Number(row.isChild) === 1;
			const isCategoryOption = !isChild && Number(row.isCategoriesOption) === 1;

			if (!isChild && !isCategoryOption) {
				const originalKey = row.parentName || row.parent;
				const parentName = originalKey && !usedKeys.has(originalKey)
					? originalKey
					: this.getUniqueParentName(row.ProductCode, rows, usedKeys);
				row.parentName = parentName;
				usedKeys.add(parentName);
				currentParent = { originalKey, parentName };
				optionKeys = new Map();
				return;
			}

			if (!currentParent) return;

			if (isCategoryOption) {
				const originalOptionKey = row.parentName;
				row.parent = currentParent.parentName;
				const optionKey = originalOptionKey && originalOptionKey !== currentParent.originalKey && !usedKeys.has(originalOptionKey)
					? originalOptionKey
					: this.getUniqueParentName(`${row.ProductCode || "option"}_option_`, rows, usedKeys);
				row.parentName = optionKey;
				usedKeys.add(optionKey);
				if (originalOptionKey && originalOptionKey !== currentParent.originalKey) {
					optionKeys.set(originalOptionKey, optionKey);
				}
				return;
			}

			const originalParent = row.parent || row.parentName;
			const normalizedParent = optionKeys.get(originalParent) || currentParent.parentName;
			row.parent = normalizedParent;
			if (row.parentName) row.parentName = normalizedParent;
		});
	}
	attachParentRelationships = (parents, categoryOptions, children) => {
		const parentsByKey = new Map();
		const optionsByKey = new Map();

		parents.forEach((parent) => {
			if (parent && parent.parentName) parentsByKey.set(parent.parentName, parent);
		});
		categoryOptions.forEach((option) => {
			if (!option) return;
			const parent = parentsByKey.get(option.parent);
			if (parent) {
				parent.CategoryOptions = parent.CategoryOptions || [];
				parent.CategoryOptions.push(option);
			}
			option.Childs = option.Childs || [];
			if (option.parentName) optionsByKey.set(option.parentName, option);
		});
		children.forEach((child) => {
			if (!child) return;
			const parent = optionsByKey.get(child.parent) || parentsByKey.get(child.parent);
			if (parent) {
				parent.Childs = parent.Childs || [];
				const parentQuantity = Number(parent.Quantity) || 1;
				child.Qty = child.Qty !== undefined && child.Qty !== null
					? child.Qty
					: Number(child.Quantity || 0) / parentQuantity;
				child.ProductDescriptionShort = child.ProductDescriptionShort || child.Discription || "";
				parent.Childs.push(child);
			}
		});
	}
	handleSelectOptionChange = (selectValue, index,productIndex) => {
		console.log(selectValue,"yoo")
		let selectedProducts = this.state.selectedProducts;
		let selectValueArray = this.state.selectOption
		let productCode = selectValue?.value?.optionsDesc;
		let product = this.props.products.find(
			({ ProductCode }) => ProductCode === productCode
		);
		if(product){
			product = JSON.parse(JSON.stringify(product))
			product.categoryIdOfOption = selectedProducts[productIndex].availableOptions[index].options[0].optionCatId
			product.Quantity = 1;
			product.isChild = 0;
			product.OptionID = selectValue.value.id
			product.ProductName = selectValue.value.optionName
			product.parent = selectedProducts[productIndex].parentName;
			product.isCategoriesOption = 1
			product.ProductPrice = selectValue?.value?.isProductPrice  ? product.ProductPrice : 0;
			product.Discription = product.ProductDescriptionShort ? product.ProductDescriptionShort.replace(/style="[^"]*"/g, "") : '';
			selectedProducts[productIndex].SelectedOption[index] = product;
			selectValueArray[selectValue.category] = selectValue
			this.setState({ selectedProducts, selectOption: selectValueArray });
			this.updateTotal(true,productIndex);
		}
		
	}
	handleOnSubmit(e,flag) {
		e.preventDefault();
		if (this.state.isSubmitting) return;
		if (!this.validateQuoteDetails()) {
			this.setState({ currentStep: 1 });
			return;
		}
		if (!this.validateProducts()) {
			this.setState({ currentStep: 2 });
			return;
		}
			var lineItems = [];
			if(this.state.selectedProducts.length &&  this.state.selectedProducts[0].ProductCode && this.state.selectedProducts[0].ProductCode !== "undefined" && this.state.selectedProducts[0].ProductCode !== null && this.state.selectedProducts[0].ProductCode !== ""){
				for (var i = 0; i < this.state.selectedProducts.length; i++) {
					if (this.state.selectedProducts[i].ProductName != undefined)
						lineItems.push({
							Quantity: this.state.selectedProducts[i].Quantity,
							ProductName: this.state.selectedProducts[i].ProductName.replace(
								/'/g,
								"\\'"
							).replace(/"/g, '\\"'),
							Discription: this.state.selectedProducts[i].Discription
								.replace(/'/g, "\\'")
								.replace(/"/g, '\\"'),
							ProductCode: this.state.selectedProducts[i].ProductCode,
							isChild: this.state.selectedProducts[i].isChild,
							isCategoriesOption :  this.state.selectedProducts[i].isCategoriesOption,
							ProductPrice: this.state.selectedProducts[i].isChild ? 0 : parseFloat(this.state.selectedProducts[i].ProductPrice),
							DiscountValue: 0,
							TaxableProduct: 1,
							parent: this.state.selectedProducts[i].parent
								? this.state.selectedProducts[i].parent
								: "",
							parentName: this.state.selectedProducts[i].parentName
								? this.state.selectedProducts[i].parentName
								: "",
						});
					if(this.state.selectedProducts[i].SelectedOption && this.state.selectedProducts[i].SelectedOption.length){
						this.state.selectedProducts[i].SelectedOption.forEach((option) => {
							if (this.state.quote.QuoteNo) {
								option.QuoteNo = this.state.quote.QuoteNo;
							}
							lineItems.push({
								Quantity: this.state.selectedProducts[i].Quantity,
								ProductName: option.ProductName.replace(/'/g, "\\'").replace(
									/"/g,
									'\\"'
								),
								Discription: option.ProductDescriptionShort? option.ProductDescriptionShort.replace(
									/'/g,
									"\\'"
								).replace(/"/g, '\\"'): "",
								ProductCode: option.ProductCode,
								isChild: option.isChild,
								OptionID: option.OptionID,
								isCategoriesOption : option.isCategoriesOption,
								ProductPrice: option.isChild ? 0 : parseFloat(option.ProductPrice),
								DiscountValue: 0,
								TaxableProduct: option.isChild ? 0 : 1,
								parent: option.parent ? option.parent : "",
								parentName: option.parentName ? option.parentName : "",
								QuoteNo: option.QuoteNo,
								categoryIdOfOption: option.categoryIdOfOption
							});
						})
						
					}
					if (
						this.state.selectedProducts[i].Childs &&
						this.state.selectedProducts[i].Childs.length
					)
						this.state.selectedProducts[i].Childs.forEach((child) => {
							if (this.state.quote.QuoteNo) {
								child.QuoteNo = this.state.quote.QuoteNo;
							}
							lineItems.push({
								Quantity: Number(child.Qty || 0) * this.state.selectedProducts[i].Quantity,
								ProductName: child.ProductName.replace(/'/g, "\\'").replace(
									/"/g,
									'\\"'
								),
								Discription: child.ProductDescriptionShort.replace(
									/'/g,
									"\\'"
								).replace(/"/g, '\\"'),
								ProductCode: child.ProductCode,
								isChild: child.isChild,
								isCategoriesOption: child.isCategoriesOption,
								ProductPrice: child.isChild ? 0 : parseFloat(child.ProductPrice),
								DiscountValue: 0,
								TaxableProduct: child.isChild ? 0 : 1,
								parent: child.parent ? child.parent : "",
								parentName: child.parentName ? child.parentName : "",
								QuoteNo: child.QuoteNo
							});
						});
				}
	
				this.setState(
					{
						quote: {
							...this.state.quote,
							ShipFirstName:this.state.quote.BillingFirstName,
							ShipLastName:this.state.quote.BillingLastName,
							BillingEmailAddress:this.state.quote.CustomerEmail,
							ShipEmailAddress:this.state.quote.CustomerEmail,
							lineItems,
							createdBy: getUser().id,
							modBy: null,
							Quote_Comments: this.state.quote.Quote_Comments ? "<span>" + this.replaceNewline(this.state.quote.Quote_Comments) + "</span>" : '',
							QuoteNotes: "",
							ShippingMethodID: 0,
							TotalShippingCost: 0,
							SalesTaxRate1: 0,
							InsuranceValue: 0,
							SelectedCustomerDiscount: false,
							QuoteDate: null,
							isApproved: 0,
							modifiedOn: null,
							IsCustomerEmailShow: 1,
							IsCustomerNameShow: 1,
							isSendEmail:flag==='email'?flag==='email':false
						},
					},
					async () => {
						this.setState({ isSubmitting: true, submissionError: "" });
						const result = await store.dispatch(SaveExternalQuote(this.state.quote));
						if (result && result.status) {
							this.setState({
								isSubmitting: false,
								completedQuoteNo: result.quoteNo || this.state.quote.QuoteNo,
							});
						} else {
							this.setState({
								isSubmitting: false,
								submissionError: result && result.msg
									? result.msg
									: "We couldn't save this quote. Check your connection and try again.",
							});
						}
						// if(flag==='email'){
						// 	this.setState({popupFlag:true})
						// 	if(this.props.match.params.QuoteId)
						// 	this.setState({href:'mailto:?subject='+this.props.match.params.QuoteId+ "/" +this.state.quote.ShipCompanyName +'&body='+this.body(this.props.match.params.QuoteId)},()=> {
						// 		if(this.state.popupFlag){
						// 			window.open(this.state.href)
						// 			console.log(this.props.match.params.QuoteId)
						// 		}
						// 	})
	
						// }else{
						// 	this.setState({popupFlag:false})
	
						// }
					}
				);
			}else{
				toast("Please select a Product","error")
			}
	}
	handleAddRowClick = (e) => {
		this.setState(
			{
				selectedProducts: [...this.state.selectedProducts, this.emptyProduct()],
			},
			() => this.updateTotal(false)
		);
	};
	replaceNewline = (val) => {
		if (val !== '') {
			return val.replace(/(?:\r\n|\r|\n)/g, '<br>');
		}

	}
	handlerRemoveRowClick = (e, index) => {
		this.setState(
			{
				selectedProducts: [
					...this.state.selectedProducts.slice(0, index),
					...this.state.selectedProducts.slice(index + 1),
				],
			},
			() => this.updateTotal(false)
		);
	};
	sameAsShipping(e) {
		const sameAsBilling = e.target.checked;
		const quote = this.state.quote;
		this.setState({
			sameAsBilling,
			quote: sameAsBilling ? {
				...quote,
				BillingAddress1: quote.ShipAddress1,
				BillingAddress2: quote.ShipAddress2,
				BillingCompanyName: quote.ShipCompanyName,
				BillingCity: quote.ShipCity,
				BillingCountry: quote.ShipCountry,
				BillingPostalCode: quote.ShipPostalCode,
				BillingState: quote.ShipState,
				BillingPhoneNumber: quote.ShipPhoneNumber,
			} : quote,
		});
	}
	sameAsBilling(e) {
		if (e.target.checked === true) {
			let quote = this.state.quote;
			this.setState({ sameAsBilling: !this.state.sameAsBilling }, () => {
				this.setState({
					quote: {
						...quote,
						...{
							ShipAddress1: quote.BillingAddress1,
							ShipAddress2: quote.BillingAddress2,
							ShipCompanyName: quote.BillingCompanyName,
							ShipCity: quote.BillingCity,
							ShipCountry: quote.BillingCountry,
							ShipPostalCode: quote.BillingPostalCode,
							ShipState: quote.BillingState,
							ShipPhoneNumber: quote.BillingPhoneNumber,
						},
					},
				});
			});
		}
	}
	emptyProduct = () => {
		return {
			ProductCode: "",
			Quantity: 1,
			ProductPrice: 0,
			ProductDescriptionShort: "",
			Childs: [],
		};
		// return this
	};
	updateTotal = (check,index) => {

		let total = this.state.selectedProducts.reduce(function (a, b) {
			return a + b["ProductPrice"] * b["Quantity"];
		}, 0)
		for (let index = 0; index < this.state.selectedProducts.length; index++) {
			if(this.state.selectedProducts[index].SelectedOption && this.state.selectedProducts[index].SelectedOption.length > 0){
				for (let j = 0; j < this.state.selectedProducts[index].SelectedOption.length; j++) {
					// console.log(this.state.selectedProducts[index].SelectedOption[j].ProductPrice * this.state.selectedProducts[index].SelectedOption[j].Quantity)
					if(this.state.selectedProducts[index].SelectedOption[j])
					total += (this.state.selectedProducts[index].SelectedOption[j].ProductPrice * this.state.selectedProducts[index].SelectedOption[j].Quantity) 
				}
			}
			
			// for (const key in this.state.selectedProducts[index].SelectedOption) {
				// if (Object.hasOwnProperty.call(this.state.selectedProducts[index].SelectedOption, key)) {
				// 	total += (this.state.selectedProducts[index].SelectedOption.ProductPrice * this.state.selectedProducts[index].SelectedOption.Quantity) 
				// }
			// }
			
		}
		if (total !== this.state.total) {
			this.setState({ total });
		}
		

	};

	resetForm = () => {
		window.location = BASE_URL + TO_QUOTE_CREATE
	}

	// getCategoriesOfOrder = (product, parentIndex) => {
	// 	if (product.OptionIDs !== "" && product.OptionIDs !== "undefined" && product.OptionIDs !== null) {
	// 		OptionService.categoriesOptionForProduct(product.OptionIDs).then(function (response) {
	// 			product.availableOptions = response.data.result
	// 			product.CategoryOptions.forEach(catOption => {
	// 				product.availableOptions.forEach((elem, ind) => {
	// 					elem.options.forEach(element => {
	// 						if (catOption.ProductCode === element.optionsDesc) {
	// 							product.availableOptions[ind].selectedCategoriesOption = element
	// 							product.availableOptions[ind].productOptionDetails = catOption
	// 							$scope.updateTotals("qty2", parentIndex);
	// 						}
	// 					});
	// 				});
	// 			})
	// 		}, function (error) {
	// 			console.log('serial fetch error', error);
	// 		})
	// 	}
	// }
	pushCategoryOption = () => {
		console.log(this.state.CategoryOptions,"yoo")

		
	}
	componentDidUpdate(prevProps) {
		if (prevProps.options !== this.props.options){
			let selectedProducts = this.state.selectedProducts;
			selectedProducts[this.props.options.index].availableOptions = this.props.options.response
			selectedProducts[this.props.options.index].SelectedOption = []
			let selectValueArray = this.state.selectOption
			if(selectedProducts[this.props.options.index].CategoryOptions){
				selectedProducts[this.props.options.index].CategoryOptions.forEach((catOption,index) => {
					selectedProducts[this.props.options.index].availableOptions.forEach((elem, ind) => {
						elem.options.forEach(element => {
							if (catOption.ProductCode === element.optionsDesc) {
								selectedProducts[this.props.options.index].SelectedOption[ind] = catOption;
								//elem.label = element.optionsDesc
								elem.value = element
								let option = {
									label : element.optionName + "["+ element.optionsDesc+ "]",
									value: element,
									category: elem.label + " " + selectedProducts[this.props.options.index].ProductCode
								}
								this.handleSelectOptionChange(option, ind,this.props.options.index)
							}
						});
					});
				})
			} else {
				selectedProducts[this.props.options.index].availableOptions.forEach((elem, ind) => {
					elem.options.forEach(element => {
						//elem.label = element.optionsDesc
						elem.value = element
						let option = {
							label : element.optionName + "["+ element.optionsDesc+ "]",
							value: element,
							category: elem.label + " " + selectedProducts[this.props.options.index].ProductCode
						}
						if(elem.value.defaultSelected === 1){
							this.handleSelectOptionChange(option, ind,this.props.options.index)
						}
					})
				})
			}
			this.setState({
				selectedProducts, selectOption: selectValueArray 
			},()=>{
				
			})
		}
		if ((JSON.stringify(prevProps.quote) !== JSON.stringify(this.props.quote) || prevProps.activeProducts !== this.props.activeProducts)) {
			let quote = this.state.quote;
			let CategoryOptions = this.state.CategoryOptions
			if (this.props.match.params.QuoteId) {
				if (this.props.quote.lineItems) {
					let selectValueArray = this.state.selectValue
					const lineItems = this.props.quote.lineItems.map((lineItem) => ({ ...lineItem }));
					this.normalizeParentRelationships(lineItems);
					let selectedProducts = lineItems.filter(
						(elem) => Number(elem.isChild) !== 1 && Number(elem.isCategoriesOption) !== 1
					);
					CategoryOptions = lineItems.filter(
						(elem) => Number(elem.isChild) !== 1 && Number(elem.isCategoriesOption) === 1
					);
					const productChilds = lineItems.filter((elem) => Number(elem.isChild) === 1);
					selectedProducts.forEach((main,index) => {
						main.CategoryOptions = []
						main.Childs = []
						if (this.props.products)
							if (this.props.products.length > 0) {
								selectValueArray.push({ label: main.ProductCode, value: main })
								let product = this.props.products.find(
									({ ProductCode }) => ProductCode === main.ProductCode
								);
								if(product) {
									if(!main.isChild && !main.isCategoriesOption){
										store.dispatch(fetchProductOptions(product.OptionIDs,index));
									}
								}
							}
					});
					this.attachParentRelationships(selectedProducts, CategoryOptions, productChilds);
					selectedProducts.forEach((main) => {
						main.SelectedOption = main.CategoryOptions.slice();
					});
					const sameAsBilling = this.props.quote.BillingAddress1 === this.props.quote.ShipAddress1 &&
						this.props.quote.BillingPostalCode === this.props.quote.ShipPostalCode;
					this.setState({
						selectedProducts,
						CategoryOptions,
						quote: { ...this.props.quote, lineItems },
						type: "Update",
						selectValue: selectValueArray,
						sameAsBilling
					});
				}
			}
			else {
				this.setState({ type: "Submit" })
			}
			this.updateTotal(false)
		}
	}
	loadInitialData = async () => {
		this.setState({ isInitialLoading: true, initialLoadError: "" });
		try {
			const requests = [
				store.dispatch(GetCountries()),
				store.dispatch(GetProducts()),
				store.dispatch(GetEndUsers()),
			];
			if (this.props.match.params.QuoteId) {
				requests.push(store.dispatch(GetQuote(this.props.match.params.QuoteId)));
			}
			await Promise.all(requests);
			this.setState({ isInitialLoading: false });
		} catch (error) {
			this.setState({
				isInitialLoading: false,
				initialLoadError: "We couldn't load the information needed to create this quote. Check your connection and try again.",
			});
		}
	};
	componentDidMount() {
		var type;
		if (this.props.match.params.QuoteId) {
			type = "Update"
		}
		else {
			type = "Submit"
		}
		this.setState(
			{
				selectedProducts: [...this.state.selectedProducts, this.emptyProduct()],
				type: type
			},
			() => {
				this.updateTotal(false);
				this.loadInitialData();
			}
		);
	}
	componentWillUnmount() {
		store.dispatch({
			type: QUOTE,
			payload: {}
		});
	}
	  
	orderItemDetails = (selectedProducts) => {
		
		let list = ""
		selectedProducts.map((obj,index) => {
           list += `<tr>
			<td valign="top">${obj.ProductCode}  </td>
			<td valign="top">${obj.ProductName}  </td> 
			<td valign="top">${obj.Quantity} <br/> </td>
			<td valign="top">${obj.ProductPrice}</td>
			<td valign="top">${obj.ProductPrice * obj.Quantity}</td>
		    </tr>`;

				obj.Childs.map((objChild)=> { 
					list += `<tr>
					<td valign="top">${objChild.ProductCode}    </td>
					<td valign="top">${objChild.ProductName}    </td> 
					<td valign="top">${objChild.Quantity * obj.Quantity}  </td>
				
			
		    		</tr>`;
				
				});
		});
			return list;
	}
	roundTo2Decimals = (number = 0.00) => {
		console.log("yooo",Math.round((number + Number.EPSILON) * 100) / 100)
		return Math.round((number + Number.EPSILON) * 100) / 100
	}
	body(){
		let quoteId
		if(this.props.match.params.QuoteId){
			 quoteId = this.props.match.params.QuoteId
		}
		else if(this.props.quotes.quoteNo){
			quoteId = this.props.quotes.quoteNo
		}
		else{
			quoteId = 0
		}
		let total = this.roundTo2Decimals(this.state.total)
		console.log(total)
		return encodeURIComponent(
			
		`<div>
		<table width="650" border="1" cellspacing="0" cellpadding="20" bgcolor="#FFFFFF" align="center">
		 <tbody><tr>
		  <td>
		   <table width="100%" border="0" cellspacing="1" cellpadding="5">
			<tbody><tr valign="top">
			     <td align="left">	<b>Quote Number:</b> ${quoteId} </td> 
				 <td align="right"><b>Customer Name:</b> ${this.state.quote.BillingFirstName + " " + this.state.quote.BillingLastName}</td>
				</tr>
			 </tbody></table>
			 <br>
		   <br>
		   <table width="100%" border="0" cellspacing="1" cellpadding="5">
			 <tbody><tr valign="top"> 
			 <td><b>Bill To:</b><br>
			 ${this.state.quote.BillingCompanyName}<br> ${this.state.quote.BillingFirstName + " " + this.state.quote.BillingLastName}<br>
			 ${this.state.quote.BillingAddress1 +" " + this.state.quote.BillingCity + " " + this.state.quote.BillingState + " " + this.state.quote.BillingPostalCode+ " " + this.state.quote.BillingCountry}<br>
			 ${this.state.quote.BillingPhoneNumber}<br>
			 <a href="mailto:${this.state.quote.CustomerEmail}" target="_blank">${this.state.quote.CustomerEmail}</a><br>
			    <br></td>
				<td><b>Ship To:</b><br>
				${this.state.quote.ShipCompanyName}<br> ${this.state.quote.BillingFirstName + " " + this.state.quote.BillingLastName} <br>
				${this.state.quote.ShipAddress1 +" " + this.state.quote.ShipCity + " " + this.state.quote.ShipState + " " + this.state.quote.ShipPostalCode}
			  <br>
			  ${this.state.quote.ShipCountry} <br>
			  ${this.state.quote.ShipPhoneNumber} <br> </td>
			  </tr>
			  <tr valign="top"> 
			 <td colspan="2"><b>Order Details:</b><br> <br>
              <table width="100%" bgcolor="#EEEEEE">
              <tbody>
              <tr>
                <td style="width: 18%"><b>Code</b></td>
                <td style="width: 52%"><b>Item / Options </b></td>
                <td style="text-align: right; width: 5%"><b>Quantity</b></td>
                <td style="text-align: right; width: 10%"><b>ProductPrice</b></td>
                <td style="text-align: right; width: 15%"><b>Grand Total</b></td>
              </tr>
			  	 ${this.orderItemDetails(this.state.selectedProducts)}
            </tbody>
			<tr>
                <td  colspan="4" style="text-align: right"><b> Subtotal:</b> </td>
                <td style="text-align: right">$${total}</td>
              </tr>
			  <tr>
                <td colspan="4" style="text-align: right"><b> Grand Total: </b></td>
                <td style="text-align: right">$${total} </td>
              </tr>
			</table>
		</div>	  
		`
		)
		
	}
	handleOpen = () => {
		this.setState({ showModal: true });
	};
	
	handleClose = () => {
		this.setState({ showModal: false });
	};
	
	handleSave = async (e) => {
		e.preventDefault();
		this.createEndUserFormRef.current.validateAll();	  
		if (this.createEndUserFormRef.current.getChildContext()._errors.length === 0) {
		  try {
			await store.dispatch(SaveEndUser(this.state.endUser));
			await store.dispatch(GetEndUsers());
			const newEndUser = this.props.endUsers[this.props.endUsers.length - 1];
			this.handleEndUserChange(newEndUser);
	  		this.handleClose();
		  } catch (error) {
			console.error('Error:', error);
		  }
		}
	  };	  
	handleEndUser = (e) => {
		const { name, value } = e.target;
		this.setState((prevState) => ({
		  endUser: {
			...prevState.endUser,
			[name]: value,
		  },
		}));
	  };
	renderLegacy() {
		const customStyles = {
			control: base => ({
				...base,
				height: 35,
				minHeight: 35
			})
		};

		return (
			<div className="quote-form">
				<div className="container">
					<Col lg="12" className="mb-3">
						<h3>{this.state.type} Quote</h3>
						<p className="text-muted"> Submit Quote to IntrepidCS</p>
					</Col>
					<div className="col-lg-12 mx-auto">
						<Form
							ref={(c) => {
								this.form = c;
							}}>
							<CustomerTopSection handleChange={this.handleChange} quote={this.state.quote} endUsersArray={(this.props.endUsers)} handleEndUserChange={this.handleEndUserChange} handleOpen={this.handleOpen}/>
							{/* <CustomerAddressSection handleChange={this.handleChange} quote={this.state.quote} sameAsShipping={this.sameAsShipping} sameAsBilling={this.sameAsBilling} countries={this.props.countries} ></CustomerAddressSection> */}
							<Modal show={this.state.showModal} onHide={this.handleClose} centered bsSize="lg">
								<Modal.Header closeButton>
									<Modal.Title>Create End User</Modal.Title>
								</Modal.Header>
								<Modal.Body>
									<CreateEndUser ref={this.createEndUserFormRef} handleChange={this.handleEndUser}/>
								</Modal.Body>
								<Modal.Footer>
									<div className="d-flex justify-content-between">
										<Button variant="secondary" onClick={this.handleClose} className="modal-buttons cancel-button">
											Cancel
										</Button>
										<Button variant="primary" onClick={this.handleSave} className="modal-buttons">
											Save
										</Button>
									</div>
								</Modal.Footer>
							</Modal>
							<Row>
								<Col lg="6" className="mb-2">
									<Row>
										<Col lg="12" className="mb-2">
											<h6>Billing Address</h6>
											<label htmlFor="sameAsShipping">
												{" "}
												<input
													onChange={this.sameAsShipping}
													id="sameAsShipping"
													name="sameAsShipping"
													type="checkbox"></input>{" "}
												Same as shipping{" "}
											</label>
										</Col>

										<Col lg="12" className="mb-3">
											<Input
												validations={[required]}
												className="input form-control custom-input"
												type="text"
												value={this.state.quote.BillingAddress1}
												name="BillingAddress1"
												onChange={this.handleChange}
												placeholder="Address 1"
											/>
										</Col>
										<Col lg="12" className="mb-3">
											<Input
												validations={[]}
												className="input form-control custom-input"
												type="text"
												value={this.state.quote.BillingAddress2}
												name="BillingAddress2"
												onChange={this.handleChange}
												placeholder="Address 2"
											/>
										</Col>
										<Col lg="12" className="mb-3">
											<Input
												validations={[required]}
												className="input form-control custom-input"
												type="text"
												value={this.state.quote.BillingCompanyName}
												name="BillingCompanyName"
												onChange={this.handleChange}
												placeholder="Company"
											/>
										</Col>
										<Col lg="12" className="mb-3">
											<Input
												validations={[required]}
												className="input form-control custom-input"
												type="text"
												value={this.state.quote.BillingCity}
												name="BillingCity"
												onChange={this.handleChange}
												placeholder="City"
											/>
										</Col>
										<Col lg="12" className="mb-3">
											<Input
												validations={[required]}
												className="input form-control custom-input"
												type="text"
												value={this.state.quote.BillingState}
												name="BillingState"
												onChange={this.handleChange}
												placeholder="State/Province"
											/>
										</Col>
										<Col lg="12" className="mb-3">
											<Input
												className="input form-control custom-input"
												type="text"
												value={this.state.quote.BillingPostalCode}
												name="BillingPostalCode"
												onChange={this.handleChange}
												placeholder="Postal Code"
											/>
										</Col>

										<Col lg="12" className="mb-3">
											<Select
												name="BillingCountry"
												validations={[required]}
												onChange={this.handleChange}
												value={this.state.quote.BillingCountry}
												id="BillingCountry"
												placeholder="Country"
												className="form-control">
												<option value="">-- Select Country --</option>
												{this.props.countries &&
													this.props.countries.map((country) => {
														return (
															<option key={country.code} value={country.code}>
																{country.name}
															</option>
														);
													})}
											</Select>
										</Col>

										<Col lg="12" className="mb-3">
											<Input
												validations={[required]}
												className="input form-control custom-input"
												type="text"
												value={this.state.quote.BillingPhoneNumber}
												name="BillingPhoneNumber"
												onChange={this.handleChange}
												placeholder="Phone Number"
											/>
										</Col>
									</Row>
								</Col>
								<Col lg="6" className="mb-2">
									<Row>
										<Col lg="12" className="mb-2">
											<h6>Shipping Address</h6>
											<label htmlFor="sameAsBilling">
												{" "}
												<input
													onChange={this.sameAsBilling}
													name="sameAsBilling"
													id="sameAsBilling"
													value={this.state.sameAsBilling}
													type="checkbox"></input>{" "}
												Same as billing{" "}
											</label>
										</Col>
										<Col lg="12" className="mb-3">
											<Input
												validations={[required]}
												className="input form-control custom-input"
												type="text"
												value={this.state.quote.ShipAddress1}
												name="ShipAddress1"
												onChange={this.handleChange}
												placeholder="Address 1"
											/>
										</Col>
										<Col lg="12" className="mb-3">
											<Input
												validations={[]}
												className="input form-control custom-input"
												type="text"
												value={this.state.quote.ShipAddress2}
												name="ShipAddress2"
												onChange={this.handleChange}
												placeholder="Address 2"
											/>
										</Col>
										<Col lg="12" className="mb-3">
											<Input
												validations={[required]}
												className="input form-control custom-input"
												type="text"
												value={this.state.quote.ShipCompanyName}
												name="ShipCompanyName"
												onChange={this.handleChange}
												placeholder="Company"
											/>
										</Col>
										<Col lg="12" className="mb-3">
											<Input
												validations={[required]}
												className="input form-control custom-input"
												type="text"
												value={this.state.quote.ShipCity}
												name="ShipCity"
												onChange={this.handleChange}
												placeholder="City"
											/>
										</Col>
										<Col lg="12" className="mb-3">
											<Input
												validations={[required]}
												className="input form-control custom-input"
												type="text"
												value={this.state.quote.ShipState}
												name="ShipState"
												onChange={this.handleChange}
												placeholder="State/Province"
											/>
										</Col>
										<Col lg="12" className="mb-3">
											<Input
												className="input form-control custom-input"
												type="text"
												value={this.state.quote.ShipPostalCode}
												name="ShipPostalCode"
												onChange={this.handleChange}
												placeholder="Postal Code"
											/>
										</Col>
										<Col lg="12" className="mb-3">
											<Select
												name="ShipCountry"
												onChange={this.handleChange}
												validations={[required]}
												value={this.state.quote.ShipCountry}
												id="ShipCountry"
												placeholder="Country"
												className="form-control">
												<option value="">-- Select Country --</option>
												{this.props.countries &&
													this.props.countries.map((country) => {
														return (
															<option key={country.code} value={country.code}>
																{country.name}
															</option>
														);
													})}
											</Select>
										</Col>
										<Col lg="12" className="mb-3">
											<Input
												validations={[required]}
												className="input form-control custom-input"
												type="text"
												value={this.state.quote.ShipPhoneNumber}
												name="ShipPhoneNumber"
												onChange={this.handleChange}
												placeholder="Phone Number"
											/>
										</Col>
									</Row>
								</Col>
								<Col lg="12" className="mb-2">
									<label htmlFor="Quote_Comments">
										Notes:
									</label>
									<FormControl
										as="textarea"
										className="form-control text-small"
										name="Quote_Comments"
										rows={7}
										style={{ fontSize: " 1rem" }}
										cols={50}
										onChange={this.handleChange}
										value={
											this.state.quote.Quote_Comments &&
											this.state.quote.Quote_Comments.replace(/(<([^>]+)>)/gi, "")
										}></FormControl>
								</Col>
							</Row>
							<Row className="mb-5">
								<Table size="sm" responsive>
									<thead>
										<tr>
											<td>
												<strong>Part Number</strong>
											</td>
											<td className="text-center">
												<strong>Description</strong>
											</td>

											<td className="text-center">
												<strong>Quantity</strong>
											</td>
											<td className="text-center">
												<strong>Unit ProductPrice ($)</strong>
											</td>
											<td className="text-right">
												<strong>Totals</strong>
											</td>
											<td className="text-center">
												<strong></strong>
											</td>
										</tr>
									</thead>
									<tbody>
										{this.state.selectedProducts &&
											this.state.selectedProducts.map(
												(selectedProduct, index) => (
													<>
														<tr key={index}>
															<td className="mb-3 tdClassForSelectIssue">
																<Select2
																	name="productList"
																	onChange={(selectValue) => this.handleSelectChange(selectValue, index)}
																	validations={[required]}
																	id="productList"
																	style={{ width: "200px" }}
																	styles={customStyles}
																	placeholder="Product Code" key={index}
																	value={this.state.selectValue[index]} label options={this.props.activeProducts && this.props.activeProducts.length > 0 && this.props.activeProducts.map(elem => { return { label: elem.ProductCode, value: elem } })} />
															</td>
															<td>
																<FormControl
																	as="textarea"
																	className="form-control text-small"
																	name="productDescription"
																	rows={1}
																	cols={50}
																	onChange={(e) => this.handleChange(e, index)}
																	value={
																		selectedProduct.Discription &&
																		selectedProduct.Discription.replace(
																			/<[^>]+>/g,
																			""
																		)
																	}></FormControl>
															</td>

															<td>
																<Input
																	type="textbox"
																	className="form-control"
																	name="Quantity"
																	validations={[required, gt0]}
																	placeholder="Quantity"
																	min={0}
																	value={selectedProduct.Quantity}
																	onChange={(e) => this.handleChange(e, index)}
																/>
															</td>
															<td>
																<FormLabel>
																	{selectedProduct.ProductPrice}
																</FormLabel>
																{/* <Input
																	type="textbox"
																	className="form-control"
																	validations={[required, numbers]}
																	name="ProductPrice"
																	placeholder="ProductPrice"
																	onChange={(e) => this.handleChange(e, index)}
																	value={selectedProduct.ProductPrice}
																/> */}
															</td>
															<td
																className="text-right"
																style={{ verticalAlign: "middle" }}>
																{(
																	selectedProduct.ProductPrice * selectedProduct.Quantity
																).toLocaleString()}
															</td>
															<td>
																<Button
																	size="sm"
																	onClick={(e) =>
																		this.handlerRemoveRowClick(e, index)
																	}>
																	<i className="fa fa-times"></i>
																</Button>
															</td>
														</tr>
														{selectedProduct.availableOptions &&  selectedProduct.availableOptions.map((categoryOption,index2 )=>(<tr key={index2}>
															<td className="mb-3 tdClassForSelectIssue">
																<FormLabel>{categoryOption.label}</FormLabel>
																<Select2
																	name="categoryOptionsList"
																	onChange={(selectCategoryOption) => this.handleSelectOptionChange(selectCategoryOption, index2,index)}
																	id="categoryOptionsList"
																	style={{ width: "200px" }}
																	styles={customStyles}
																	placeholder="Product Code" key={categoryOption.key}
																	value={this.state.selectOption[categoryOption.label + " " + selectedProduct.ProductCode]}
																	label={categoryOption.label} options={categoryOption.options.map(option => { return { label: option.optionName + "["+ option.optionsDesc+ "]" , value: option, category: categoryOption.label  + " " + selectedProduct.ProductCode} })} />
															</td>
															<td>
																<FormControl
																	as="textarea"
																	className="form-control text-small"
																	name="productDescription"
																	rows={1}
																	cols={50}
																	onChange={(e) => this.handleChange(e, index)}
																	value={
																		selectedProduct.SelectedOption && selectedProduct.SelectedOption[index2] &&
																		selectedProduct.SelectedOption[index2].Discription.replace(
																			/<[^>]+>/g,
																			""
																		)
																	}></FormControl>
															</td>
															<td>
															<FormLabel>
															{selectedProduct.Quantity}
															</FormLabel>
															
															</td>
															<td>
																<FormLabel>
																	{selectedProduct.SelectedOption && selectedProduct.SelectedOption[index2] && selectedProduct.SelectedOption[index2].ProductPrice}
																</FormLabel>
															</td>
															<td
																className="text-right"
																style={{ verticalAlign: "middle" }}>
																{selectedProduct.SelectedOption &&  selectedProduct.SelectedOption[index2] && (
																	(selectedProduct.SelectedOption[index2].ProductPrice * selectedProduct.SelectedOption[index2].Quantity)
																).toLocaleString()}
															</td>
														</tr>))}
														{selectedProduct.Childs &&
															selectedProduct.Childs.map(
																(ChildrenOfSelectedProduct, childIndex) => (
																	<tr>
																		<td>
																			{ChildrenOfSelectedProduct.ProductCode}
																		</td>
																		<td>
																			<FormControl
																				as="textarea"
																				className="form-control text-small"
																				name="productDescriptionChild"
																				rows={1}
																				cols={50}
																				onChange={(e) =>
																					this.handleChange(e, index, childIndex)
																				}
																				value={
																					ChildrenOfSelectedProduct.ProductDescriptionShort
																				}></FormControl>
																		</td>
																			
																		<td>
																			{console.log(ChildrenOfSelectedProduct)}
																			{ChildrenOfSelectedProduct.Qty *
																				selectedProduct.Quantity}
																		</td>
																		<td></td>
																		<td></td>
																	</tr>
																)
															)}
													</>
												)
											)}
										<tr>
											<td colSpan="100%" className="text-right">
												<Button size="sm" onClick={this.handleAddRowClick}>
													{" "}
													Add More{" "}
												</Button>
											</td>
										</tr>
									</tbody>
								</Table>
								<Col lg="6" className="mb-2" />
								<Col lg="6" className="mb-2 d-flex justify-content-between">
									<h6>SubTotal:</h6>
									<strong>${this.state.total.toLocaleString()}</strong>
								</Col>
								<Col lg="6" className="mb-2" />
								<Col lg="6" className="mb-2 d-flex justify-content-between">
									<h2> Total:</h2>
									<h2>${this.state.total.toLocaleString()}</h2>
								</Col>
								<Col lg="12" className="text-right  d-flex flex-row-reverse">
								<Button onClick={(e)=>this.handleOnSubmit(e,'email')} size="sm" type="button" className="mw-100 ml-2" variant="success" value="saveAndEmail" >  
										{/* {this.state.type} Save */}
										Save and Email
									</Button>
									<Button onClick={(e) => this.handleOnSubmit(e,'save')} size="sm" type="button" className="mw-100 ml-2" value="save">
										Save
									</Button>
									{!this.props.match.params.QuoteId && <Button size="sm" variant="danger" onClick={this.resetForm} className="mw-100 ml-1">
										Reset 
									</Button>}
								</Col>

							</Row>
						</Form>
					</div>
				</div>
			</div>
		);
	}
	render() {
		const { currentStep, completedQuoteNo, isSubmitting, submissionError, isInitialLoading, initialLoadError } = this.state;
		const isEdit = Boolean(this.props.match.params.QuoteId);
		const steps = ["Customer & delivery", "Products", "Review"];

		if (isInitialLoading) {
			return (
				<main className="quote-form redesigned-quote-form">
					<div className="quote-shell quote-loading" role="status" aria-live="polite">
						<div className="loading-heading"></div>
						<div className="loading-progress"></div>
						<div className="loading-section"><span></span><span></span><span></span><span></span></div>
						<p>Loading quote details...</p>
					</div>
				</main>
			);
		}

		if (initialLoadError) {
			return (
				<main className="quote-form redesigned-quote-form">
					<div className="quote-load-error" role="alert">
						<i className="fa fa-exclamation-circle" aria-hidden="true"></i>
						<h1>Quote details couldn’t load</h1>
						<p>{initialLoadError}</p>
						<div><Button variant="primary" onClick={this.loadInitialData}>Try again</Button> <Link className="btn btn-outline-secondary" to={TO_QUOTE_LIST}>Return to quotes</Link></div>
					</div>
				</main>
			);
		}

		if (completedQuoteNo) {
			return (
				<main className="quote-form redesigned-quote-form">
					<div className="quote-success" role="status">
						<div className="success-icon"><i className="fa fa-check" aria-hidden="true"></i></div>
						<span className="section-kicker">Quote saved</span>
						<h1>Quote #{completedQuoteNo} is ready</h1>
						<p>{isEdit ? "Your changes have been saved." : "The quote was created successfully."}</p>
						<div className="success-actions">
							<Link className="btn btn-primary" to={TO_QUOTE_LIST}>View quotes</Link>
							{!isEdit && <Button variant="outline-primary" onClick={this.resetForm}>Create another quote</Button>}
						</div>
					</div>
				</main>
			);
		}

		return (
			<main className="quote-form redesigned-quote-form">
				<div className="quote-shell">
					<header className="quote-page-header">
						<div>
							<span className="page-eyebrow">External quotes</span>
							<h1>{isEdit ? `Edit quote #${this.props.match.params.QuoteId}` : "Create a quote"}</h1>
							<p>Build and submit a detailed quote request to IntrepidCS.</p>
						</div>
						<Link className="cancel-quote-link" to={TO_QUOTE_LIST}>
							<i className="fa fa-times" aria-hidden="true"></i>
							<span>Cancel quote</span>
						</Link>
					</header>

					<nav className="quote-progress" aria-label="Quote creation progress">
						{steps.map((label, index) => {
							const step = index + 1;
							const isComplete = step < currentStep;
							return (
								<button
									type="button"
									key={label}
									className={`${step === currentStep ? "active" : ""} ${isComplete ? "complete" : ""}`}
									onClick={() => step <= currentStep && this.goToStep(step)}
									disabled={step > currentStep}
									aria-current={step === currentStep ? "step" : undefined}>
									<span>{isComplete ? <i className="fa fa-check" aria-hidden="true"></i> : step}</span>
									<strong>{label}</strong>
								</button>
							);
						})}
					</nav>

					{submissionError && (
						<div className="quote-error-summary" role="alert">
							<i className="fa fa-exclamation-circle" aria-hidden="true"></i>
							<div><strong>We need a little more information.</strong><p>{submissionError}</p></div>
						</div>
					)}

					<form onSubmit={(event) => event.preventDefault()}>
						{currentStep === 1 && (
							<QuoteDetailsStep
								quote={this.state.quote}
								countries={this.props.countries}
								endUsers={this.props.endUsers}
								sameAsBilling={this.state.sameAsBilling}
								handleChange={this.handleChange}
								handleEndUserChange={this.handleEndUserChange}
								handleOpen={this.handleOpen}
								sameAsShipping={this.sameAsShipping}
							/>
						)}
						{currentStep === 2 && (
							<QuoteProductsStep
								selectedProducts={this.state.selectedProducts}
								activeProducts={this.props.activeProducts}
								selectValue={this.state.selectValue}
								selectOption={this.state.selectOption}
								handleSelectChange={this.handleSelectChange}
								handleSelectOptionChange={this.handleSelectOptionChange}
								handleChange={this.handleChange}
								handleAddRowClick={this.handleAddRowClick}
								handlerRemoveRowClick={this.handlerRemoveRowClick}
								total={this.state.total}
							/>
						)}
						{currentStep === 3 && (
							<QuoteReviewStep
								quote={this.state.quote}
								selectedProducts={this.state.selectedProducts}
								total={this.state.total}
								goToStep={this.goToStep}
							/>
						)}

						<footer className="quote-actions">
							<div className="quote-actions-context">
								<span>Step {currentStep} of 3</span>
								<strong>{steps[currentStep - 1]}</strong>
							</div>
							<div className="quote-action-buttons">
								{currentStep > 1 && <Button variant="outline-secondary" onClick={() => this.goToStep(currentStep - 1)} disabled={isSubmitting}>Back</Button>}
								{currentStep < 3 && <Button variant="primary" onClick={this.continueToNextStep}>Continue</Button>}
								{currentStep === 3 && (
									<>
										<Button variant="outline-primary" onClick={(event) => this.handleOnSubmit(event, "save")} disabled={isSubmitting}>
											Save quote only
										</Button>
										<Button variant="primary" onClick={(event) => this.handleOnSubmit(event, "email")} disabled={isSubmitting}>
											{isSubmitting ? <><span className="button-spinner" aria-hidden="true"></span> Saving quote...</> : <><i className="fa fa-paper-plane" aria-hidden="true"></i> {isEdit ? "Save changes and notify" : "Create quote and notify"}</>}
										</Button>
									</>
								)}
							</div>
						</footer>
					</form>
				</div>

				<Modal show={this.state.showModal} onHide={this.handleClose} centered size="lg" dialogClassName="end-user-modal">
					<Modal.Header>
						<Modal.Title>Add an end user</Modal.Title>
						<Button variant="link" className="modal-close-button" onClick={this.handleClose} aria-label="Close">
							<i className="fa fa-times" aria-hidden="true"></i>
						</Button>
					</Modal.Header>
					<Modal.Body>
						<p className="modal-intro">Create an end-user record and attach it to this quote.</p>
						<CreateEndUser ref={this.createEndUserFormRef} handleChange={this.handleEndUser}/>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="outline-secondary" onClick={this.handleClose}>Cancel</Button>
						<Button variant="primary" onClick={this.handleSave}>Add end user</Button>
					</Modal.Footer>
				</Modal>
			</main>
		);
	}
}
const stateMap = (state) => {
	return {
		user: state.user,
		products: state.user.products,
		activeProducts: state.user.activeProducts,
		countries: state.user.countries,
		global: state.global,
        options: state.user.options,
		quote: state.user.quote,
		quotes: state.user.quotes,
		endUsers: state.user.endUsers
	};
};
export default connect(stateMap)(QuoteForm);
